import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CustomReportUserFavoriteClient } from '.././reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class CustomReportUserFavoriteService {
    constructor(private readonly client: CustomReportUserFavoriteClient) {}

    async toggleFavorite(id: number): Promise<boolean> {
        return await lastValueFrom(this.client.customReportUserFavoriteToggleFavorite(id));
    }
}
